export default [{
    path: "/user/register",
    name: "register",
    component: resolve => require(["./Register.vue"], resolve)
}];


// WEBPACK FOOTER //
// ./src/views/user/router.js